import './styles/TextBadge.scss';

import * as React from 'react';

import Text from 'components/Text';
import cx from 'classnames';

export type TextBadgeColor =
  | 'pitch'
  | 'lava'
  | 'shamrock'
  | 'wolf'
  | 'polar-bear'
  | 'eclipse'
  | 'sunrise'
  | 'coaching-orange-lightest';
export type TextBadgeTextColor = 'white' | 'thunder' | 'pitch' | 'lava' | 'flame';

type NonDefaultProps = {
  children: React.ReactNode;
  className?: string;
};

type DefaultProps = {
  color: TextBadgeColor;
  textSize: 'xsmall' | 'xxxxsmall';
  textColor: TextBadgeTextColor;
  textWeight: 'normal' | 'semibold';
};

export type Props = NonDefaultProps & DefaultProps;

class TextBadge extends React.Component<Props> {
  static defaultProps: DefaultProps = {
    color: 'polar-bear',
    textColor: 'thunder',
    textWeight: 'semibold',
    textSize: 'xsmall',
  };

  render() {
    const { color, textColor, textWeight, textSize, children, className } = this.props;

    return (
      <Text
        color={textColor}
        weight={textWeight}
        size={textSize}
        className={cx('TextBadge', `TextBadge--${color}`, `TextBadge--${textSize}`, className)}
        element="div">
        {children}
      </Text>
    );
  }
}

export default TextBadge;
